module.exports = __webpack_public_path__ + "static/media/feature-split-image-01.af2da127.png";